interface FormatNumberOptions {
    precision?: number;
    locale?: DoclerNumberLocales;
}

type DoclerNumberLocales = 'en-US';

export const formatNumber = (num: number, options?: FormatNumberOptions) => {
    const precision = options?.precision ?? undefined;
    const locale = options?.locale ?? 'en-US';

    if (typeof precision !== 'number') {
        return Intl.NumberFormat(locale).format(num);
    }

    return Intl.NumberFormat(locale, {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
    }).format(num);
};

export const abbreviateNumber = (num: number) => {
    if (num >= 1000000) return `${Math.round(num / 1000000)}M`;
    if (num >= 1000) return `${Math.round(num / 1000)}K`;
    return `${num}`;
};
